import React, { useState } from 'react';
import {
  Box,
  Divider,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  IconButton
} from '@mui/material';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import koLocale from '@fullcalendar/core/locales/ko';
import '@fullcalendar/common/main.min.css';
import '@fullcalendar/daygrid/main.min.css';
import './calendar.css';

// 비주얼 리뉴얼(2026-10-23) - "점 + 짧은 바" 형태로 압축한다. 상세(작업예정자/직급/부서)는
// 여전히 보여주되 작게 묶어서 한 줄을 넘지 않게 한다 - 전체 정보는 클릭 시 모달에서 볼 수 있다.
function renderEventContent(eventInfo) {
  const dotColor = eventInfo.event.backgroundColor || eventInfo.event.borderColor || '#1976d2';
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, overflow: 'hidden', width: '100%' }}>
      <Box component="span" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: dotColor, flexShrink: 0 }} />
      <Typography variant="caption" component="span" noWrap sx={{ fontWeight: 600 }}>
        {eventInfo.event.title}
      </Typography>
      {eventInfo.event.extendedProps?.usrNm && (
        <Typography variant="caption" component="span" color="text.secondary" noWrap>
          · {eventInfo.event.extendedProps.usrNm}
        </Typography>
      )}
      {eventInfo.timeText && (
        <Typography variant="caption" component="span" color="text.secondary" noWrap>
          {eventInfo.timeText}
        </Typography>
      )}
    </Box>
  );
}
//https://github.com/fullcalendar/fullcalendar-example-projects/blob/master/react-redux/src/DemoApp.jsx
const DashboardCalendar = ({ events, handelEventClick, toggleCalFull, full }) => {
  const [weekendsVisible, setWeekendsVisible] = useState(true);
  const handleChange = () => {
    setWeekendsVisible(!weekendsVisible);
  };

  // console.log(events,"events");



  return (
    <Box
      sx={{
        px: 2,
        mb: 2
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox size="small" checked={weekendsVisible} onChange={handleChange} />
              }
              label={<Typography variant="body2">토,일 포함</Typography>}
            />
          </FormGroup>
        </Box>
        <Box>
          <IconButton
            size="small"
            onClick={toggleCalFull}
            aria-label={full ? '일정 전체화면 접기' : '일정 전체화면으로 보기'}
          >
            {full ? (<CloseFullscreenIcon fontSize="small" />) : (<OpenInFullIcon fontSize="small" />)}
          </IconButton>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay',
        }}
        // 비주얼 리뉴얼(2026-10-23): locale prop 이름이 틀려(adapterLocale은 FullCalendar가
        // 인식하지 못하는 prop) 한국어 로케일이 실제로는 한 번도 적용되지 않았었다(제목이
        // 늘 "October 2026" 처럼 영어로 나왔다) - locale로 고치면 제목("2026년 10월")·요일
        // 머리글("일·월·화…")이 같이 한글로 바뀐다.
        locale={koLocale}
        buttonText={{ today: '오늘', month: '월간', week: '주간', day: '일간' }}
        // ko 로케일 기본 날짜 숫자는 "23일"처럼 접미사가 붙어 오늘 표시용 원(24px) 안에서
        // 줄바꿈됐다(2026-10-23 실측 스크린샷에서 발견) - 숫자만 보여줘서 원 안에 깔끔히 들어가게 한다.
        dayCellContent={(arg) => arg.date.getDate()}
        height={full ? '1200px' : '600px'}
        initialView="dayGridMonth"
        weekends={weekendsVisible}
        nextDayThreshold="09:00:00"
        events={events}
        eventContent={renderEventContent}
        nowIndicator
        eventClick={(e) => handelEventClick(e)}
      />
    </Box>
  );
};

export default DashboardCalendar;
